import { all, takeEvery, put, fork, call } from "redux-saga/effects";
import {
  getBizInvoiceError,
  getBizInvoiceSuccess,
  //plopImportAction
} from "../actions/BizInvoiceActions.js";
import {
  GET_INVOICE_INIT,
  GET_BIZ_INVOICE_INIT,
  //plopImportConstant
} from "redux/constants/BizInvoiceConstants.js";

import FirebaseService from "services/FirebaseService";

export function* GetBizInvoice() {
  yield takeEvery(GET_BIZ_INVOICE_INIT, function* () {
    try {
      const data = yield call(FirebaseService.fetchCollection, "Bizinvoice");
        // Manual sorting by createdAt in descending order
        const sortedData = data.sort((a, b) => {
            const aSeconds = a.createdAt ? a.createdAt.seconds : 0;
            const bSeconds = b.createdAt ? b.createdAt.seconds : 0;
            return bSeconds - aSeconds;
          });
    
          // Manual filtering for accountStatus === "nonactive"
          const filteredData = sortedData.filter(element => element.gstType === "Biz");
      // const data = yield call(FirebaseService.fetchCollection, "Bizinvoice", {
      //   sort: {
      //     attribute: "createdAt",
      //     order: "desc",
      //   },
      // });
      let changeTime = filteredData.map((element) => {
        var d = new Date(0);
        d.setUTCSeconds(element.createdAt.seconds);
        return {
          ...element,
          createdAt: `${d}`,
        };
      });

      console.log(
        "🚀 ~ file: InvoiceSaga.js ~ line 22 ~ changeTime ~ changeTime",
        changeTime
      );

      yield put(getBizInvoiceSuccess(changeTime));
    } catch (error) {
      console.log(
        "🚀 ~ file: InvoiceSaga.js ~ line 41 ~ yieldtakeEvery ~ error",
        error.message
      );
      yield put(getBizInvoiceError(error));
    }
  });
}
//plopSaga
export default function* rootSaga() {
  yield all([
    fork(GetBizInvoice),
    //plopExport
  ]);
}
